/* ============================================================
   JENIS POST TIKTOK — Video (lalai) atau Photo post (gambar card)
   (2026-11-04, PLAN_TIKTOK_POST_GAMBAR.md · docs/ai/tiktok.md §8)

   Per-BROWSER (localStorage), sama seperti suis TikTok Checks / beg kuning.
   Ditulis HANYA dalam pengendali klik (bukan effect).

   Laluan ke robot: `tetapanJenisPostTiktok()` dibaca SEMASA payload dibina dan
   dimasukkan ke kotak terbuka `tetapan` pada KEDUA-DUA laluan Run TikTok
   (WorkspaceView: kalendar + tick card). content.ts menghantar `tetapan`
   bulat-bulat; background.ts (ZIP baharu) membaca `jenisPost` untuk mengambil
   gambar card dan menghantarnya kepada robot.

   ⚠️ KEMBAR:
   · `jenisPost` dibaca oleh background.ts (`modGambar`) DAN robot
     tiktok-automation.js (`_ttModGambar`). Tukar nama = tukar di tiga tempat.
   · `gambarKad` = takrifan SAMA dengan `senaraiGambarKad` dalam extension
     `src/chrome/tiktokGambar.ts` (utama dahulu, kemudian tambahan, http(s)
     sahaja, tanpa pendua). Ubah satu = ubah dua-dua.
   ⚠️ Extension LAMA (tanpa ZIP ini) mengabaikan `jenisPost` dan akan cuba post
   VIDEO set itu — gate versi extension perlu dinaikkan sebelum pilihan ini
   dibuka kepada pelanggan (izin user).
   ============================================================ */

export const KUNCI_JENIS_POST = 'sesaat_tt_jenis_post_v1';
const HAD_GAMBAR_TIKTOK = 35;

/* 'gambar' hanya bila tersimpan EKSPLISIT. Apa-apa lain (tiada / storan ditutup) = 'video'. */
export function bacaJenisPostTiktok() {
  try { return localStorage.getItem(KUNCI_JENIS_POST) === 'gambar' ? 'gambar' : 'video'; } catch { return 'video'; }
}

/* Pulang true bila berjaya disimpan — pemanggil memberitahu pelanggan bila gagal. */
export function tulisJenisPostTiktok(jenis) {
  try { localStorage.setItem(KUNCI_JENIS_POST, jenis === 'gambar' ? 'gambar' : 'video'); return true; } catch { return false; }
}

/* Medan untuk kotak `tetapan` payload Run TikTok. */
export function tetapanJenisPostTiktok() {
  return { jenisPost: bacaJenisPostTiktok() };
}

/* Gambar card yang akan dipost: utama dahulu (= Cover), kemudian tambahan. */
export function gambarKad(kad) {
  const calon = [kad?.imageUrl, ...(Array.isArray(kad?.extraImageUrls) ? kad.extraImageUrls : [])];
  const keluar = [];
  for (const u of calon) {
    if (typeof u !== 'string' || !/^https?:\/\//i.test(u.trim())) continue;
    const bersih = u.trim();
    if (!keluar.includes(bersih)) keluar.push(bersih);
  }
  return keluar.slice(0, HAD_GAMBAR_TIKTOK);
}

/* Post gambar = SATU post setiap card → status ditulis pada set PERTAMA yang dipilih sahaja.
   (Menanda semua set 'running' akan meninggalkan set lain tersangkut 'running' selamanya.) */
export function setLarianTiktok(setDipilih, jenis) {
  const sets = Array.isArray(setDipilih) ? setDipilih : [];
  if (jenis !== 'gambar') return sets;
  return [...sets].sort().slice(0, 1);
}
